import { render, staticRenderFns } from "./secondchunai.vue?vue&type=template&id=00d53b76&scoped=true"
import script from "./secondchunai.vue?vue&type=script&lang=js"
export * from "./secondchunai.vue?vue&type=script&lang=js"
import style0 from "./secondchunai.vue?vue&type=style&index=0&id=00d53b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d53b76",
  null
  
)

export default component.exports